/* POSTIFULL - Hizli bakis (quick view) · 2026-10-19 · YAYIN SURUMU: "Hizli ekle butonu"
   Kart tiklamasi normal sekilde urun sayfasina gider. Kartin gorselindeki "Hizli Bak" (telefonda goz ikonu) butonu
   kompakt pencere acar: kucuk gorsel, ad, fiyat (sepet fiyati dahil), boyut secimi, sepete ekle.
   Icerik: /products/<handle>?view=qv (templates/product.qv.liquid).
   Not: kod 5 secenegi de icerir (v45'te incelendi); bu surumde V = 3 sabit, secici ve ?qv= kapali. */
(function () {
  'use strict';
  if (window.__pfqv) return;
  window.__pfqv = true;

  var V = 3; // 3 = hizli ekle butonu (sabit)

  var CARD = '.v2c-card, .pfc-card';
  var cache = {};
  var ov = null, box = null, lastFocus = null, pushed = false;
  var list = [], idx = -1; // secenek 4: sayfadaki urun listesi

  function money(cents, fmt) {
    var m = (fmt || '{{amount}}').match(/\{\{\s*(\w+)\s*\}\}/), n = cents / 100;
    function f(num, dec, th, ds) { var p = num.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(ds); }
    var out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = f(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = f(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = f(n, 0, '.', ','); break;
      default: out = f(n, 2, ',', '.');
    }
    return (fmt || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
  }

  function qvUrl(href) {
    var u = new URL(href, location.origin);
    u.search = '';
    u.hash = '';
    u.searchParams.set('view', 'qv');
    var pt = new URL(location.href).searchParams.get('preview_theme_id');
    if (pt) u.searchParams.set('preview_theme_id', pt);
    return u.toString();
  }
  function get(href) {
    var url = qvUrl(href);
    return cache[url] || (cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (t) { if (t.indexOf('data-pfqv-root') === -1) throw new Error('bad'); return t; })
      .catch(function (e) { delete cache[url]; throw e; }));
  }

  var IC = {
    x: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    l: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>',
    r: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>',
    eye: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg>'
  };

  function build() {
    ov = document.createElement('div');
    ov.className = 'pfqv-ov pfqv-ov--v' + V;
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Hızlı bakış');
    var pn = V === 4 ? '<div class="pfqv-pn"><button type="button" class="pfqv-pn__b" data-pn="-1" aria-label="Önceki ürün">' + IC.l + '</button><span class="pfqv-pn__c" data-pn-c></span><button type="button" class="pfqv-pn__b" data-pn="1" aria-label="Sonraki ürün">' + IC.r + '</button></div>' : '';
    ov.innerHTML = '<div class="pfqv-box">' + pn + '<button type="button" class="pfqv-x" aria-label="Kapat">' + IC.x + '</button><div class="pfqv-body"></div></div>';
    box = ov.querySelector('.pfqv-box');
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    ov.querySelector('.pfqv-x').addEventListener('click', close);
    ov.querySelectorAll('[data-pn]').forEach(function (b) { b.addEventListener('click', function () { step(+b.getAttribute('data-pn')); }); });
    document.body.appendChild(ov);
  }

  function collect() {
    var seen = {}, out = [];
    document.querySelectorAll(CARD).forEach(function (c) {
      var a = c.querySelector('a[href*="/products/"]'); if (!a) return;
      var k = new URL(a.href, location.origin).pathname;
      if (seen[k]) return; seen[k] = 1; out.push(a.href);
    });
    return out;
  }
  function samePath(a, b) { return new URL(a, location.origin).pathname === new URL(b, location.origin).pathname; }

  function load(href) {
    var body = ov.querySelector('.pfqv-body');
    body.innerHTML = '<div class="pfqv-load"><i></i>Yükleniyor…</div>';
    if (V === 4) {
      var c = ov.querySelector('[data-pn-c]');
      if (c) c.textContent = (idx + 1) + ' / ' + list.length;
      ov.querySelectorAll('[data-pn]').forEach(function (b) {
        var d = +b.getAttribute('data-pn'); b.disabled = idx + d < 0 || idx + d >= list.length;
      });
    }
    get(href).then(function (html) {
      if (!ov.classList.contains('is-open')) return;
      if (V === 4 && list[idx] && !samePath(list[idx], href)) return; // hizli gezinmede eski yanit
      body.innerHTML = html;
      wire(body.querySelector('[data-pfqv-root]'));
      if (V === 4) { [idx - 1, idx + 1].forEach(function (i) { if (list[i]) get(list[i]).catch(function () {}); }); }
    }).catch(function () { window.location.href = href; });
  }

  function open(href) {
    if (!ov) build();
    lastFocus = document.activeElement;
    if (V === 4) {
      list = collect();
      idx = -1;
      for (var i = 0; i < list.length; i++) if (samePath(list[i], href)) { idx = i; break; }
      if (idx < 0) { list = [href]; idx = 0; }
    }
    ov.style.display = 'flex';
    document.documentElement.classList.add('pfqv-lock');
    requestAnimationFrame(function () { ov.classList.add('is-open'); });
    if (!pushed) { try { history.pushState({ pfqv: 1 }, ''); pushed = true; } catch (e) {} }
    document.addEventListener('keydown', onKey);
    load(href);
    var x = ov.querySelector('.pfqv-x'); if (x) x.focus({ preventScroll: true });
  }

  function step(d) {
    if (V !== 4) return;
    var n = idx + d;
    if (n < 0 || n >= list.length) return;
    idx = n;
    load(list[idx]);
  }

  function close(fromPop) {
    if (!ov || !ov.classList.contains('is-open')) return;
    ov.classList.remove('is-open');
    document.documentElement.classList.remove('pfqv-lock');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { if (!ov.classList.contains('is-open')) { ov.style.display = 'none'; ov.querySelector('.pfqv-body').innerHTML = ''; } }, 260);
    if (pushed && fromPop !== true) { pushed = false; try { history.back(); } catch (e) {} }
    pushed = false;
    // secenek 4: en son bakilan urunun kartina kaydir
    if (V === 4 && list[idx]) {
      var a = document.querySelector(CARD.split(',').map(function (s) { return s.trim() + ' a[href*="' + new URL(list[idx], location.origin).pathname + '"]'; }).join(','));
      if (a) { var card = a.closest(CARD); if (card) setTimeout(function () { card.scrollIntoView({ block: 'center' }); }, 120); lastFocus = null; }
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    if (V === 4 && (e.key === 'ArrowRight' || e.key === 'ArrowLeft') && !/input|textarea/i.test((e.target && e.target.tagName) || '')) step(e.key === 'ArrowRight' ? 1 : -1);
  }
  window.addEventListener('popstate', function () { if (ov && ov.classList.contains('is-open')) { pushed = false; close(true); } });

  function parseSize(s) {
    var m = String(s || '').replace(',', '.').match(/(\d+(?:\.\d+)?)\s*[x×X]\s*(\d+(?:\.\d+)?)/);
    return m ? { w: +m[1], h: +m[2] } : null;
  }

  function wire(root) {
    if (!root) return;
    var D = {};
    try { D = JSON.parse(root.querySelector('[data-pfqv-data]').textContent); } catch (e) {}
    var variants = D.variants || [];
    var cur = null;
    variants.forEach(function (v) { if (v.id === D.selected) cur = v; });
    cur = cur || variants[0];
    var sel = cur ? cur.o.slice() : [];

    // gorsel seridi
    var strip = root.querySelector('[data-pfqv-strip]');
    var dots = root.querySelectorAll('.pfqv__dot');
    var thumbs = [];
    function idxOf() { return strip ? Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth)) : 0; }
    function go(i) { if (strip) strip.scrollTo({ left: i * strip.clientWidth, behavior: 'smooth' }); }
    function mark() {
      var i = idxOf();
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }
    if (strip) {
      strip.addEventListener('scroll', mark, { passive: true });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-i')); }); });
      var prev = root.querySelector('[data-pfqv-prev]'), next = root.querySelector('[data-pfqv-next]');
      var total = strip.children.length;
      if (prev) prev.addEventListener('click', function () { go(Math.max(0, idxOf() - 1)); });
      if (next) next.addEventListener('click', function () { go(Math.min(total - 1, idxOf() + 1)); });
      // secenek 2 + 4: kucuk resimler
      if ((V === 2 || V === 4) && total > 1) {
        var tw = document.createElement('div');
        tw.className = 'pfqv__thumbs';
        Array.prototype.forEach.call(strip.querySelectorAll('img'), function (im, k) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'pfqv__thumb' + (k === 0 ? ' is-on' : ''); b.setAttribute('aria-label', 'Görsel ' + (k + 1));
          b.innerHTML = '<img src="' + (im.currentSrc || im.src) + '" alt="" loading="lazy">';
          b.addEventListener('click', function () { go(k); });
          tw.appendChild(b); thumbs.push(b);
        });
        strip.parentNode.appendChild(tw);
      }
    }

    // secenek 5: duvarda boyut
    var wall = null, sizeOpt = -1;
    if (V === 5 && variants.length) {
      for (var j = 0; j < sel.length; j++) if (parseSize(sel[j])) { sizeOpt = j; break; }
      var media = root.querySelector('.pfqv__media');
      var firstImg = strip && strip.querySelector('img');
      if (sizeOpt > -1 && media && firstImg) {
        var src = firstImg.currentSrc || firstImg.src;
        var tabs = document.createElement('div');
        tabs.className = 'pfqv__tabs';
        tabs.innerHTML = '<button type="button" class="is-on" data-t="p">Fotoğraflar</button><button type="button" data-t="w">Duvarda boyut</button>';
        wall = document.createElement('div');
        wall.className = 'pfqv__wall';
        wall.innerHTML = '<div class="pfqv__room"><div class="pfqv__art"><img src="' + src + '" alt=""></div>' +
          '<svg class="pfqv__sofa" viewBox="0 0 200 82" preserveAspectRatio="none" aria-hidden="true"><rect x="10" y="4" width="180" height="44" rx="8"/><rect x="0" y="30" width="24" height="42" rx="7"/><rect x="176" y="30" width="24" height="42" rx="7"/><rect x="18" y="44" width="164" height="26" rx="5"/><rect x="14" y="70" width="5" height="12"/><rect x="181" y="70" width="5" height="12"/></svg>' +
          '<div class="pfqv__floor"></div></div><div class="pfqv__wcap" data-wcap></div>';
        media.appendChild(wall);
        media.appendChild(tabs);
        tabs.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          showWall(b.getAttribute('data-t') === 'w');
        });
      }
    }
    function showWall(on) {
      if (!wall) return;
      root.classList.toggle('is-wall', on);
      root.querySelectorAll('.pfqv__tabs button').forEach(function (b) { b.classList.toggle('is-on', (b.getAttribute('data-t') === 'w') === on); });
    }
    function drawWall() {
      if (!wall) return;
      var s = parseSize(sel[sizeOpt]); if (!s) return;
      var RW = 280, RH = 210, FLOOR = 8, SOFA = 82, GAP = 20;
      var bottom = FLOOR + SOFA + GAP;
      if (bottom + s.h > RH - 6) bottom = Math.max(FLOOR + 4, RH - 6 - s.h);
      var art = wall.querySelector('.pfqv__art');
      art.style.width = (s.w / RW * 100) + '%';
      art.style.height = (s.h / RH * 100) + '%';
      art.style.bottom = (bottom / RH * 100) + '%';
      wall.querySelector('[data-wcap]').innerHTML = '<b>' + s.w + ' × ' + s.h + ' cm</b> · kanepe genişliği ≈ 200 cm';
    }

    var priceEl = root.querySelector('[data-pfqv-price]');
    var idEl = root.querySelector('[data-pfqv-id]');
    var atc = root.querySelector('[data-pfqv-atc]');
    var atcTx = root.querySelector('[data-pfqv-atc-text]');

    function find() {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) if (variants[i].o[j] !== sel[j]) { ok = false; break; }
        if (ok) return variants[i];
      }
      return null;
    }

    function render() {
      var v = find();
      if (v) cur = v;
      if (priceEl && cur) {
        var ref = cur.c > cur.p ? cur.c : cur.p;
        if (cur.k > 0) {
          var off = Math.round((ref - cur.k) / ref * 100);
          priceEl.innerHTML = '<span class="pfqv__was">' + money(ref, D.moneyFormat) + '</span><span class="pfqv__cart"><small>Sepette</small>' + money(cur.k, D.moneyFormat) + '</span>' + (off > 0 ? '<span class="pfqv__off">-%' + off + '</span>' : '');
        } else {
          priceEl.innerHTML = '<span class="pfqv__now">' + money(cur.p, D.moneyFormat) + '</span>' + (cur.c > cur.p ? '<span class="pfqv__was">' + money(cur.c, D.moneyFormat) + '</span><span class="pfqv__off">-%' + Math.round((cur.c - cur.p) / cur.c * 100) + '</span>' : '');
        }
      }
      root.querySelectorAll('[data-pfqv-opt]').forEach(function (bx) {
        var k = +bx.getAttribute('data-pfqv-opt');
        var lab = bx.querySelector('[data-pfqv-optval]'); if (lab) lab.textContent = sel[k];
        bx.querySelectorAll('.pfqv__chip').forEach(function (c) {
          var val = c.getAttribute('data-value');
          c.classList.toggle('is-on', val === sel[k]);
          var test = sel.slice(); test[k] = val;
          var has = variants.some(function (x) { return x.a && x.o.every(function (o, j) { return o === test[j]; }); });
          c.classList.toggle('is-na', !has);
        });
      });
      if (idEl && v) idEl.value = v.id;
      if (atc) {
        var ok = !!(v && v.a);
        atc.disabled = !ok;
        if (atcTx) atcTx.textContent = !v ? 'Bu seçenek yok' : (v.a ? 'Sepete Ekle' : 'Tükendi');
      }
      drawWall();
    }

    root.querySelectorAll('[data-pfqv-opt]').forEach(function (bx) {
      var k = +bx.getAttribute('data-pfqv-opt');
      bx.addEventListener('click', function (e) {
        var c = e.target.closest('.pfqv__chip'); if (!c) return;
        sel[k] = c.getAttribute('data-value');
        render();
        if (k === sizeOpt) showWall(true);
      });
    });
    render();
  }

  // sepete eklenince (temanin product-form'u -> sepet cekmecesi acilir) pencereyi kapat
  document.addEventListener('variant:add', function (e) {
    if (ov && ov.classList.contains('is-open') && e.target && e.target.closest && e.target.closest('.pfqv-ov')) setTimeout(close, 50);
  });

  if (V === 3) {
    // secenek 3: kart tiklamasi normal; kartin gorselinde "Hizli Bak" butonu
    var addBtns = function () {
      document.querySelectorAll(CARD).forEach(function (card) {
        if (card.__pfqvb) return;
        var a = card.querySelector('a[href*="/products/"]');
        var media = card.querySelector('.v2c-card__media, .pfc-card__media');
        if (!a || !media) return;
        card.__pfqvb = 1;
        media.classList.add('pfqv-hasqb');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pfqv-qb';
        b.setAttribute('aria-label', 'Hızlı bak');
        b.innerHTML = IC.eye + '<span>Hızlı Bak</span>';
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(a.href); });
        media.appendChild(b);
      });
    };
    addBtns();
    new MutationObserver(function () { addBtns(); }).observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!a || !a.closest(CARD) || a.closest('.pfqv-ov')) return;
      if (a.target === '_blank') return;
      e.preventDefault();
      e.stopPropagation();
      open(a.href);
    }, true);
  }

})();
